import Vue from 'vue';
import store from '../store';

import VueTheMask from "vue-the-mask";
import {BootstrapVue} from "bootstrap-vue";

import PartnerPackageSingle from '../components/Partners/Onboarding/PackageSingle';
import GetStartedForm from '../components/forms/GetStartedForm.vue';
import GetQuoteForm from '../components/forms/GetQuoteForm.vue';
import SetupAccountForm from '../components/forms/SetupAccountForm.vue';
import InviteHousemateForm from '../components/forms/InviteHousematesForm.vue';
import SetupPaymentForm from '../components/forms/SetupPaymentForm';
import SuccessForm from '../components/forms/SuccessForm';

Vue.use(VueTheMask);
Vue.use(BootstrapVue);

Vue.component('GetStartedForm', GetStartedForm);
Vue.component('GetQuoteForm', GetQuoteForm);
Vue.component('SetupAccountForm', SetupAccountForm);
Vue.component('InviteHousematesForm', InviteHousemateForm);
Vue.component('SetupPaymentForm', SetupPaymentForm);
Vue.component('SuccessForm', SuccessForm);
Vue.component('PartnerPackageSingle', PartnerPackageSingle);

const app = new Vue({
    el: '#app',
    store
});
